import { Component, OnInit } from '@angular/core';
import { AppService } from '../../services/app.service';
import { HealthMinistryService } from '../../services/health-ministry.service';
import { IResident } from '../../models/HealthMinistry';
import { Utils } from '../../core/Utils';
import { ActivatedRoute, Router } from '@angular/router';

export interface IItem extends IResident {
    title: string;
    dateFrom?: Date;
    dateTo?: Date;
}

export interface IFilterOptions {
    status: string[];
    speciality: string[];
    studyYear: number[];
    workplace: string[];
    clinicalBase: string[];
    studyType: string[];
    financeType: string[];
}

export const defaultFilterOptions = {
    status: [],
    speciality: [],
    studyYear: [],
    workplace: [],
    clinicalBase: [],
    studyType: [],
    financeType: []
};

const cache: {
    residents?: IItem[],
    filters?: IFilterOptions
} = {};

@Component({
    selector: 'app-health-ministry-dashboard',
    templateUrl: './health-ministry-dashboard.component.html'
})
export class HealthMinistryDashboardComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: HealthMinistryService,
        private readonly route: ActivatedRoute,
        private readonly router: Router
    ) { }

    activeTabId: number = 1;
    residents: IItem[];
    filters: IFilterOptions = defaultFilterOptions;

    private readonly tabs = {
        residents: 1,
        stats: 2
    };

    ngOnInit() {
        this.route.queryParams.subscribe(para => {
            let tab = (para.tab || '').toLowerCase();

            if (!this.tabs[tab]) tab = 'residents';

            this.activeTabId = this.tabs[tab];
        });

        if (cache.residents) {
            this.residents = cache.residents;
            this.filters = cache.filters;
        } else {
            this.app.addLoading(this.service.getResidents()).subscribe(data => {
                this.residents = cache.residents = data.map(t => {
                    return {
                        ...t,
                        title: `${t.Name} ${t.Surname} (${t.CertNumber})`,
                        dateFrom: Utils.ensureDate(t.StudyBeginDate),
                        dateTo: Utils.ensureDate(t.StudyPlannedEndDate)
                    };
                });

                this.buildFilters();
            });
        }
    }

    private buildFilters() {
        const statuses: string[] = [];
        const years: number[] = [];
        const specs: string[] = [];
        const workplaces: string[] = [];
        const clinicalBases: string[] = [];
        const studyTypes: string[] = [];
        const financeTypes: string[] = [];

        this.residents.forEach(t => {
            if (t.StudentStatusName && !statuses.includes(t.StudentStatusName)) statuses.push(t.StudentStatusName);
            if (!years.includes(t.StudyYear)) years.push(t.StudyYear);
            if (t.StudyProgramName && !specs.includes(t.StudyProgramName)) specs.push(t.StudyProgramName);
            if (t.WorkplaceName && !workplaces.includes(t.WorkplaceName)) workplaces.push(t.WorkplaceName);
            if (t.ClinicalBaseName && !clinicalBases.includes(t.ClinicalBaseName)) clinicalBases.push(t.ClinicalBaseName);
            if (t.StudyTypeName && !studyTypes.includes(t.StudyTypeName)) studyTypes.push(t.StudyTypeName);
            if (t.StudyFinanceTypeName && !financeTypes.includes(t.StudyFinanceTypeName)) financeTypes.push(t.StudyFinanceTypeName);
        });

        const lang = this.app.currentLanguage;

        statuses.sort((a, b) => a.localeCompare(b, lang));
        years.sort();
        specs.sort((a, b) => a.localeCompare(b, lang));
        workplaces.sort((a, b) => a.localeCompare(b, lang));
        clinicalBases.sort((a, b) => a.localeCompare(b, lang));
        studyTypes.sort((a, b) => a.localeCompare(b, lang));
        financeTypes.sort((a, b) => a.localeCompare(b, lang));

        this.filters.status = statuses;
        this.filters.studyYear = years;
        this.filters.speciality = specs;
        this.filters.workplace = workplaces;
        this.filters.clinicalBase = clinicalBases;
        this.filters.studyType = studyTypes;
        this.filters.financeType = financeTypes;

        cache.filters = this.filters;
    }
}
